<template>
  <!-- 左侧菜单栏 -->
  <xui-menu ref="J_userCenter" class="user-center__menu" :default-active="activeIndex" @select="selectHandle">
    <xui-menu-item index="1" class="user-center__menu-item">
      <span slot="title">个人资料</span>
    </xui-menu-item>
    <xui-menu-item index="2" class="user-center__menu-item">
      <span slot="title">身份认证</span>
    </xui-menu-item>
    <xui-menu-item index="3" class="user-center__menu-item">
     <span slot="title">我的漏洞<span v-if="unReadBbsCount && unReadBbsCount > 0" class="user-center__menu-number--fixed">{{ unReadBbsCount }}</span></span>
    </xui-menu-item>
    <xui-menu-item index="4" class="user-center__menu-item">
       <span slot="title">消息中心<span v-if="unReadMsgListCount && unReadMsgListCount > 0" class="user-center__menu-number--fixed">{{ unReadMsgListCount }}</span></span>
    </xui-menu-item>
    <xui-menu-item index="5" class="user-center__menu-item">
      <span slot="title">团队菜单</span>
    </xui-menu-item>
  </xui-menu>
</template>
<script>
import router from '../../router/index.js';
import { mapState } from 'vuex';
export default {
  name: 'UserCenterMenu',
  computed: {
    ...mapState(['unReadBbsCount', 'unReadMsgListCount'])
  },
  data() {
    return {
      activeIndex: '1'
    };
  },
  mounted () {
    document.querySelector('.xui-menu .switcher').style.display = 'none'
    const meta = this.$route.meta
    // this.$refs['J_userCenter'].active(meta.userCenterMenuIndex);
    this.activeIndex = meta.userCenterMenuIndex
  },
  methods: {
    selectHandle: (index, indexPath) => {
      if (index === '1') {
        router.push({ path: '/usercenter/info' });
      }
      if (index === '2') {
        router.push({ path: '/usercenter/idinfo' });
      }
      if (index === '3') {
        router.push({ path: '/usercenter/report' });
      }
      if (index === '4') {
        router.push({ name: 'usercenterSiteMsg' });
      }
      if (index === '5') {
        router.push({ path: '/usercenter/teamMenu' });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.user-center__menu {
  width: 310px;
  min-width: 310px;
  height: var(--src--user-page-min-height);
  padding-top: 40px;
  margin-right:20px;
  background: var(--src-text-color-white);
  box-shadow: 0px 4px 9px -3px rgba(0,0,0,0.2);
  border-radius: 10px;
}

.user-center__menu-item{
  position: relative;
  display:flex;
  align-items: center;
  justify-content: center;
  height: 66px;
  border-left:none!important;
  font-size: var(--src--text-size-large-extra1);
  color: var(--src-color-primary-dark5);
  font-weight: var(--src-text-weight-light1);
  transition: none;
  &.is-active{
    background: var(--src-bg-color-dark1);
    color: var(--src-text-color-white);
    border-left:none!important;
    &:hover {
      background: var(--src-bg-color-dark1)!important;
      color: var(--src-text-color-white)!important;
      border-left:none!important;
    }
  }
  &:hover{
      border-left:none!important;
    background-color: var(--src-bg-color-transparent)!important;
    color: var(--src-color-primary-dark5)!important;
    opacity: 0.8;
  }
}

.user-center__menu-number--fixed{
    position: absolute;
    left: 194px;
    top: 9px;
    height: 15px;
    line-height: 15px;
    padding: 0 4px;
    background-color: var(--src-bg-color-red-light1);
    font-size: 12px;
    color: var(--src-text-color-white);
    border-radius: 7px;
    max-width: 66px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/UserCenterMenu.vue